import React from 'react';
import { TableFilters, BelongsToFilterSelects } from '../../design-system';
import { FiltersSetStatesProp } from '../../types';

interface Props {
  setStates: FiltersSetStatesProp;
}

export const Filters: React.FC<Props> = ({ setStates }: Props) => {
  return (
    <TableFilters>
      <BelongsToFilterSelects
        handleChange={(obj) => {
          setStates('force', obj);
        }}
        filtersType={'sales-fees'}
      />
    </TableFilters>
  );
};
